export default __webpack_public_path__ + "static/media/coin-full-distorted.521e376d.png";